// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
/**
 * Refinement specifies the refinements supported by the AI model.
 */
export var Refinement;
(function (Refinement) {
    Refinement["REFINEMENT_UNSPECIFIED"] = "REFINEMENT_UNSPECIFIED";
    Refinement["REFINEMENT_SHORTEN"] = "REFINEMENT_SHORTEN";
    Refinement["REFINEMENT_LENGTHEN"] = "REFINEMENT_LENGTHEN";
})(Refinement || (Refinement = {}));
export var Refinement_index;
(function (Refinement_index) {
    Refinement_index[Refinement_index["REFINEMENT_UNSPECIFIED"] = 0] = "REFINEMENT_UNSPECIFIED";
    Refinement_index[Refinement_index["REFINEMENT_SHORTEN"] = 1] = "REFINEMENT_SHORTEN";
    Refinement_index[Refinement_index["REFINEMENT_LENGTHEN"] = 2] = "REFINEMENT_LENGTHEN";
})(Refinement_index || (Refinement_index = {}));
/**
 * FeedbackType specifies the type of feedback.
 */
export var FeedbackType;
(function (FeedbackType) {
    FeedbackType["FEEDBACK_TYPE_BAD"] = "FEEDBACK_TYPE_BAD";
    FeedbackType["FEEDBACK_TYPE_GOOD"] = "FEEDBACK_TYPE_GOOD";
})(FeedbackType || (FeedbackType = {}));
export var FeedbackType_index;
(function (FeedbackType_index) {
    FeedbackType_index[FeedbackType_index["FEEDBACK_TYPE_BAD"] = 0] = "FEEDBACK_TYPE_BAD";
    FeedbackType_index[FeedbackType_index["FEEDBACK_TYPE_GOOD"] = 1] = "FEEDBACK_TYPE_GOOD";
})(FeedbackType_index || (FeedbackType_index = {}));
export const SmsReplyAssistant = {
    /**
     * GenerateReply generates a SMS reply for the given thread conversation.
     */
    GenerateReply(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
            fm.validateUrlParam(req["threadId"], "threadId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/sms/reply-assistant/v1/generate/${req["locationId"]}/${req["threadId"]}`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * SubmitFeedback submits feedback for the generated AI draft.
     */
    SubmitFeedback(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
            fm.validateUrlParam(req["threadId"], "threadId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/sms/reply-assistant/v1/feedback/${req["locationId"]}/${req["threadId"]}`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
